import enLocale from 'element-ui/lib/locale/lang/en'
const en={
   enLocale,
}

export default en

